import { render, staticRenderFns } from "./referential-employee-role.vue?vue&type=template&id=37f33f40&"
import script from "./referential-employee-role.vue?vue&type=script&lang=ts&"
export * from "./referential-employee-role.vue?vue&type=script&lang=ts&"
import style0 from "./referential-employee-role.vue?vue&type=style&index=0&id=37f33f40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports